import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { SessionService } from '../../shared/services/session.service';
import * as $ from "jquery";


@Component({
  selector: 'app-bladderblocket',
  templateUrl: './bladderblocket.component.html',
  styleUrls: ['./bladderblocket.component.scss']
})
export class BladderblocketComponent implements OnInit {
  public bloburl: string;


  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<BladderblocketComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {

    this.bloburl = this.sessionService.bloburl;
  }


  ngOnInit() {
    
  }


  //New concept for print btn
  autoprintloadText(event: any) {
    var txtChar = event.key;
    if (txtChar) {
      this.hideshowprintbtn(1);
    }
  }

  hideshowprintbtn(st: any) {
    if (st == 1) {
      $("#printpdf").removeClass("disabled_me");
    }
    else {
      $("#printpdf").addClass("disabled_me");
    }
  }

  removeText() {
    var thisme = this;
    setTimeout(function () {
      var b = $("#textfield").text();
      var images = $(".draggableme");
      if (b == "" && images) {
        if (images.length == 0) {
          thisme.hideshowprintbtn(2);
        }
      }
      else if (b == "") {
        thisme.hideshowprintbtn(2);
      }
    }, 100);
  }
  //New concept

  async ngAfterViewInit() {


    
    var text_editor_container = document.querySelector("#textfield");
    var editor = document.getElementById("#textfield");
    text_editor_container.addEventListener("touchstart", this.touchHandler, true);
    text_editor_container.addEventListener("touchmove", this.touchHandler, true);
    text_editor_container.addEventListener("touchend", this.touchHandler, true);
    text_editor_container.addEventListener("touchcancel", this.touchHandler, true);

    text_editor_container.addEventListener("touchstart", removeborders);

    function removeborders(e) {
      if ($(e.target).attr('class') != 'draggableme') {

     
        $(".draggableme").css("border", "none");
        $(".closeimg").css("display", "none");
      }
    }



  }

 

  touchHandler(event) {


    var touch = event.changedTouches[0];

    var simulatedEvent = document.createEvent("MouseEvent");
    simulatedEvent.initMouseEvent({
      touchstart: "mousedown",
      touchmove: "mousemove",
      touchend: "mouseup"
    }[event.type], true, true, window, 1,
      touch.screenX, touch.screenY,
      touch.clientX, touch.clientY, false,
      false, false, false, 0, null);

    if ($(event.target).attr('class') == 'draggableme') {
      touch.target.dispatchEvent(simulatedEvent);
    }
   

  }

  toggleTable1(i) {
    var TableA1 = document.getElementById("yr3_bladder_imageTable2");
    var imgarr11: any[string];
    imgarr11 = [TableA1];
    imgarr11[i].style.display = (imgarr11[i].style.display == "table") ? "none" : "table";
  }


  changeColor(i) {
    var e1 = document.getElementById("bladdercircle1");
    var c1 = window.getComputedStyle(e1).backgroundColor;

    var circlearr: any[string];
    circlearr = [e1];

    var circlearr1: any[string];
    circlearr1 = [c1];

    if (circlearr1[i] === "rgb(255, 255, 255)") {
      circlearr[i].style.background = "#ED8505";
    } else {
      circlearr[i].style.background = "#FFFFFF";
    }
  }

  showimage(j) {

    //new concept for print btn
    var txt = $("#textfield").text();
    if (txt) {
      
      this.hideshowprintbtn(1);
    }
    else {
      this.hideshowprintbtn(2);
    }


    //typing text after placing the image in safari
    var issafari_browser = navigator.userAgent.indexOf('Mac OS X') != -1;
    if (issafari_browser) {
      var a = $("#textfield").text();
      if (!a || a == "") {
        $("#textfield").prepend("&nbsp;");
      }
    }

    var elem = document.getElementById("textfield");
    var elem_notepad = document.getElementById("notepad");

    var copy_text = document.getElementById("copy_text");
    var elembody = document.getElementsByTagName("body")[0];
    var imgarr1: any[string];
    imgarr1 = [
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image1.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image2.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image3.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image4.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image5.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image6.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image7.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image8.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image9.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image10.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image11.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image12.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image13.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image14.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image15.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image18.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image16.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image17.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image19.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image20.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image21.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image22.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image23.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image24.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image25.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image26.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image27.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image28.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image29.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image30.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image31.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image32.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image33.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image34.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image35.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image36.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image37.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image38.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image39.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image40.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image41.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image42.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image43.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image44.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image45.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image46.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image47.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image48.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image49.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image50.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image51.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image52.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image53.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image54.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image55.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image56.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image57.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image58.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image59.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image60.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image61.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image62.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image63.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image64.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image65.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image66.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image67.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image68.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image69.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image70.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image71.png',
      '../../../../../assets/yr3-tincan/bladderblocket/images/table1_images/table1_images_big/image72.png'


    ];
    imgarr1.width = [109, 129, 125, 163, 109, 131, 128, 140, 101,
      122, 151, 109, 148, 166, 161, 95, 153, 147,
      173, 159, 109, 156, 116, 174, 111, 94, 132,
      108, 203, 118, 114, 153, 203, 93, 149, 110,
      94, 123, 135, 121, 165, 118, 124, 66, 148,
      78, 136, 123, 145, 84, 177, 158, 95, 100,
      154, 167, 127, 178, 145, 114, 216, 181, 122,
      168, 173, 268, 176, 157, 144, 175, 170, 174
    ];

    imgarr1.height = [127, 116, 120, 99, 117, 108, 135, 91, 117,
      109, 128, 130, 110, 83, 80, 123, 126, 126,
      104, 97, 140, 135, 98, 129, 122, 95, 96,
      115, 97, 140, 128, 126, 106, 152, 164, 102,
      136, 175, 168, 113, 179, 138, 158, 143, 205,
      109, 199, 146, 133, 152, 172, 162, 143, 136,
      82, 118, 96, 120, 95, 114, 151, 98, 104,
      145, 108, 125, 90, 97, 120, 132, 77, 162

    ];
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    if (isIOS) {
      imgarr1.width = [
        54.5, 64.5, 62.5, 81.5, 54.5, 65.5, 64, 70, 50.5,
        61, 75.5, 54.5, 74, 83, 80.5, 47.5, 76.5, 73.5,
        86.5, 79.5, 54.5, 78, 58, 87, 55.5, 47, 66,
        54, 101.5, 59, 57, 76.5, 101.5, 46.5, 74.5, 55,
        47, 61.5, 67.5, 60.5, 82.5, 59, 62, 33, 74,
        39, 68, 61.5, 72.5, 42, 88.5, 79, 47.5, 50,
        77, 83.5, 63.5, 89, 72.5, 57, 108, 90.5, 61,
        84, 86.5, 134, 88, 78.5, 72, 87.5, 85, 87
      ];

      imgarr1.height = [
        63.5, 58, 60, 49.5, 58.5, 54, 67.5, 45.5, 58.5,
        54.5, 64, 65, 55, 41.5, 40, 61.5, 63, 63,
        52, 48.5, 70, 67.5, 49, 64.5, 61, 47.5, 48,
        57.5, 48.5, 70, 64, 63, 53, 76, 82, 51,
        68, 87.5, 84, 56.5, 89.5, 69, 79, 71.5, 102.5,
        54.5, 99.5, 73, 66.5, 76, 86, 81, 71.5, 68,
        41, 59, 48, 60, 47.5, 57, 75.5, 49, 52,
        72.5, 54, 62.5, 45, 48.5, 60, 66, 38.5, 81
      ];

    }

    var elem = document.getElementById("textfield");

    var div = document.createElement("div");
    div.style.position = "absolute";
    div.style.left = elem_notepad.offsetWidth / 2 - imgarr1.width[j] / 2 - 44 + 'px';
    div.style.top = elem_notepad.offsetHeight / 2 - imgarr1.height[j] / 2 - 64 + 'px';
    div.style.width = imgarr1.width[j] + "px";
    div.style.height = imgarr1.height[j] + "px";
    div.style.background = "FFFFFF";
    div.style.backgroundImage = "url('" + imgarr1[j] + "')";
    if (isIOS) {
      div.style.backgroundSize = imgarr1.width[j] + "px";
    }
    div.contentEditable = "false";
    div.style.cursor = 'pointer';
    $(div).addClass("draggableme");
    var closeimg = document.createElement('img');
    closeimg.src = this.bloburl + "/Lasresan/AK3/YR3-Tincan/Bladderblocket/Images/close.png";
    closeimg.style.display = "none";
    closeimg.style.position = "absolute";
    closeimg.style.left = elem_notepad.offsetWidth / 2 + imgarr1.width[j] / 2 - 60 + 'px';
    closeimg.style.top = elem_notepad.offsetHeight / 2 - imgarr1.height[j] / 2 - 79 + 'px';
    closeimg.style.zIndex = '1000';
    closeimg.width = 30;
    if (isIOS) {
      closeimg.width = 25;
    }
    closeimg.style.cursor = 'pointer';
    $(closeimg).addClass("closeimg");
    //new concept for print btn
    this.hideshowprintbtn(1);

    elem.appendChild(div);
    elem.appendChild(closeimg);
   

    var closetable1 = document.getElementById("yr3_bladder_imageTable2");
    closetable1.style.display = "none";

    var changecolor1 = document.getElementById("bladdercircle1");
    changecolor1.style.background = "#FFFFFF";

    var mousePosition;
    var offset = [0, 0, 0, 0];
    var isDown = false;

    div.addEventListener('mousedown', function (e) {
      e.preventDefault();
      isDown = true;
      offset = [
        div.offsetLeft - e.clientX,
        div.offsetTop - e.clientY,
        closeimg.offsetLeft - e.clientX,
        closeimg.offsetTop - e.clientY
      ];
    }, true);

    div.addEventListener('mouseup', function () {
      isDown = false;
    }, true);

    document.addEventListener('mouseup', function () {
      isDown = false;
    }, true);

    div.addEventListener('mousemove', function (event) {
      event.preventDefault();
      if (isDown) {
        mousePosition = {

          x: event.clientX,
          y: event.clientY,

          x1: event.clientX,
          y1: event.clientY

        };
        div.style.left = (mousePosition.x + offset[0]) + 'px';
        div.style.top = (mousePosition.y + offset[1]) + 'px';

        closeimg.style.left = (mousePosition.x1 + offset[0]) + imgarr1.width[j] - 15 + 'px';
        closeimg.style.top = (mousePosition.y1 + offset[1]) - 14 + 'px';
      }
      if (div.style.left == "0px") {
        return false;
      }
    }, true);



    div.addEventListener("touchstart", TouchOver);
    div.addEventListener("touchmove", TouchOver);
    closeimg.addEventListener("touchstart", removeimg);
   
    div.addEventListener("mouseover", MouseOver);
    div.addEventListener("mouseleave", MouseLeave);
    closeimg.addEventListener("mouseover", MouseOver);
    closeimg.addEventListener("mouseleave", MouseLeave);

    function TouchOver(e) {
      $(".draggableme").css("border", "none");
      $(".closeimg").css("display", "none");
      div.style.border = "#000000 1px solid";
      closeimg.style.display = "block";
    }
    function MouseOver() {
      div.style.border = "#000000 1px solid";
      closeimg.style.display = "block";
    }
    function MouseLeave() {
      div.style.border = "none";
      closeimg.style.display = "none";
    }

    closeimg.addEventListener("click", removeimg);


    //New concept for print btn
    function hideshowprintbtn(st) {
      if (st == 1) {
        $("#printpdf").removeClass("disabled_me");
      }
      else {
        $("#printpdf").addClass("disabled_me");
      }
    }
    //New concept

    function removeimg() {
      div.remove();
      closeimg.remove();

      //New concept for print btn
      var b = $("#textfield").text();
      var images = $(".draggableme");
      if (b == "" && images) {
        if (images.length == 0) {
          hideshowprintbtn(2);
        }
      }
      else if (b == "") {
        hideshowprintbtn(2);
      }
      //New concept

    }
  }


  onCloseCancel() {
    this.thisDialogRef.close('Cancel');    
  }

}
